import React from "react";
export default function ExaminersIcons() {
  return (
    <>
      <svg
        width="200"
        height="150"
        viewBox="0 0 800 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.0146 409.196C48.0479 409.678 48.0822 410.174 48.1166 410.684C48.5023 416.09 47.4393 420.394 46.4216 424.514C46.362 424.756 46.3026 424.996 46.2437 425.236C45.1769 429.581 44.2356 433.847 44.9068 439.441C45.1321 441.294 46.076 443.84 47.4352 446.779C48.6747 449.459 50.1963 452.335 51.6756 455.132C51.8006 455.369 51.9253 455.604 52.0495 455.839C53.628 458.827 55.1402 461.72 56.0952 464.05C56.5705 465.209 56.9413 466.308 57.0972 467.254C57.1892 467.812 57.24 468.509 57.0503 469.166C61.2552 476.488 67.6875 484.995 74.5757 492.174C81.712 499.613 89.1363 505.412 94.9388 507.175L95.3995 507.315L95.6768 507.709C95.7833 507.86 95.8625 507.938 95.9087 507.977C96.179 507.86 96.6458 507.451 97.3379 506.574C97.748 506.054 98.1387 505.505 98.5562 504.919C98.8366 504.525 99.1292 504.114 99.4479 503.683C100.181 502.692 101.028 501.637 101.959 500.921L101.978 500.906L101.997 500.892C103.491 499.822 104.716 499.196 105.646 498.721L105.726 498.68C106.72 498.172 107.14 497.927 107.418 497.599C107.646 497.331 107.888 496.863 107.998 495.652C108.111 494.425 108.075 492.629 107.899 489.858C107.768 487.957 107.496 485.885 107.215 483.749C107.169 483.401 107.123 483.051 107.078 482.7C106.756 480.224 106.453 477.691 106.412 475.416L106.412 475.403V475.391C106.412 473.492 106.742 471.873 107.04 470.414C107.081 470.211 107.122 470.012 107.161 469.815C107.485 468.188 107.724 466.66 107.515 464.771C107.074 461.151 105.102 456.267 102.805 451.161C102.229 449.881 101.633 448.588 101.042 447.307C99.3259 443.584 97.6532 439.956 96.6444 437.018C94.1909 429.892 90.4149 419.929 85.732 411.594C83.3894 407.425 80.8516 403.721 78.1809 400.991C75.4966 398.246 72.8042 396.614 70.1552 396.314L70.1522 396.314C69.9413 396.289 69.6329 396.327 69.1673 396.487C68.7016 396.647 68.2036 396.884 67.6 397.171L67.5936 397.174C67.5606 397.189 67.5271 397.205 67.4932 397.221C66.413 397.735 64.901 398.455 63.3446 398.351L63.3346 398.35L63.3246 398.349C61.6959 398.217 59.9294 397.441 58.4281 396.781C58.3307 396.738 58.2345 396.696 58.1395 396.654C56.4245 395.903 55.0277 395.337 53.8697 395.307C51.7992 395.251 50.5096 395.549 49.688 396.028C48.9246 396.473 48.4113 397.165 48.0856 398.305C47.7453 399.496 47.637 401.092 47.6827 403.203C47.7202 404.936 47.8571 406.918 48.0146 409.196ZM53.9434 392.506C51.6392 392.444 49.7448 392.752 48.2765 393.608C46.7498 394.498 45.8667 395.872 45.3915 397.535C44.9311 399.146 44.8343 401.09 44.8814 403.264C44.9205 405.069 45.0632 407.134 45.2209 409.413C45.254 409.891 45.2877 410.379 45.3212 410.876L45.3216 410.881C45.6755 415.835 44.7095 419.753 43.6841 423.912C43.6303 424.13 43.5764 424.349 43.5225 424.568C42.4409 428.973 41.3901 433.653 42.1249 439.776L42.1252 439.778C42.4078 442.105 43.5245 444.998 44.8921 447.955C46.1647 450.706 47.721 453.649 49.1923 456.43C49.3197 456.671 49.4464 456.91 49.5722 457.149C51.1674 460.167 52.6094 462.933 53.5025 465.112C53.9514 466.208 54.2281 467.076 54.3325 467.71C54.399 468.113 54.3756 468.295 54.3659 468.351L53.7585 469.034L54.2476 469.905C58.5709 477.599 65.3251 486.58 72.5538 494.114C79.579 501.437 87.2448 507.598 93.6993 509.721C94.0456 510.116 94.4627 510.444 94.9688 510.633C95.6719 510.895 96.3589 510.818 96.9441 510.581C97.98 510.162 98.8562 509.173 99.5377 508.309C99.9766 507.753 100.452 507.086 100.91 506.445C101.184 506.061 101.451 505.687 101.7 505.35C102.42 504.378 103.062 503.613 103.649 503.155C104.962 502.217 106.027 501.673 106.937 501.208L107.076 501.137C107.93 500.701 108.867 500.223 109.555 499.412C110.313 498.519 110.653 497.39 110.789 495.908C110.923 494.442 110.871 492.451 110.695 489.677L110.695 489.669C110.557 487.673 110.272 485.502 109.992 483.371C109.946 483.026 109.901 482.681 109.856 482.339C109.534 479.858 109.252 477.474 109.214 475.378C109.215 473.786 109.486 472.452 109.783 470.986C109.825 470.781 109.867 470.573 109.91 470.361C110.25 468.65 110.557 466.781 110.299 464.455L110.298 464.448L110.297 464.441C109.799 460.328 107.631 455.058 105.36 450.011C104.75 448.656 104.132 447.315 103.528 446.005C101.833 442.328 100.253 438.899 99.294 436.107L99.2937 436.106C96.8253 428.936 92.9841 418.782 88.1748 410.222C85.7713 405.944 83.0942 402.006 80.1839 399.031C77.2875 396.07 74.0332 393.934 70.4719 393.53C69.6677 393.437 68.9024 393.615 68.2551 393.838C67.6381 394.05 67.0151 394.346 66.4678 394.606C66.4421 394.619 66.4167 394.631 66.3914 394.643C65.1387 395.238 64.2769 395.601 63.5404 395.556C62.3975 395.46 61.0261 394.86 59.3148 394.11L59.2634 394.088C57.6779 393.393 55.7539 392.554 53.9434 392.506Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M324.14 505.157C322.969 503.282 323.437 507.657 323.437 509.532C323.515 513.282 324.375 517.11 324.922 520.782C325.547 524.375 325.937 527.891 326.25 531.485C342.265 542.5 337.344 513.828 335.625 505.86"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M308.749 528.203C298.749 533.75 287.421 536.25 276.328 539.531C266.562 542.422 265.937 549.062 277.265 549.219C294.062 549.375 320.859 549.375 335.937 541.953C344.296 537.812 342.734 529.531 342.265 521.562C336.953 522.969 337.656 527.422 330.703 526.562C326.718 526.094 323.828 523.516 321.406 520.859C318.906 524.453 310.546 526.25 308.749 528.203Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M346.25 393.281C344.063 394.141 346.875 404.297 347.188 408.594H456.406C456.406 407.188 456.406 406.875 456.406 407.656C456.094 402.734 453.672 397.813 455.469 393.203H346.25V393.281Z"
          fill="#B5CDFB"
        ></path>
        <path
          d="M466.563 337.031C465.078 342.344 466.406 353.203 464.609 358.359C463.203 362.422 460.938 365.234 461.25 369.766C450.703 370.156 440.781 372.422 430.234 372.578C409.531 372.813 387.969 371.172 367.344 369.844C358.438 369.297 358.359 364.609 354.609 356.953C348.516 344.531 354.375 335.156 349.922 321.563C349.922 321.328 467.813 332.891 466.563 337.031Z"
          fill="#7D55FF"
        ></path>
        <path
          d="M455.781 505.859C455.547 507.266 454.14 532.656 457.031 536.719C459.375 540 462.812 539.687 466.406 540.625C468.281 530.625 468.437 510.234 467.89 502.734"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M445.625 532.11C444.375 534.61 445.078 537.578 447.11 539.531C453.985 546.25 461.016 561.016 467.422 568.125C471.094 572.266 475.703 576.875 481.016 578.75C485.625 580.469 490.469 576.484 489.61 571.641C488.594 565.469 484.844 560 482.031 554.453C476.641 543.985 481.016 536.797 480.078 525.938C474.844 525.938 470.469 528.672 465.547 528.281C466.328 531.719 466.094 535.235 463.75 537.656C460.313 534.844 457.266 528.36 455.703 524.141C451.641 523.985 446.797 529.766 445.625 532.11Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M142.422 323.359C152.891 323.75 163.047 326.563 173.594 326.953C187.344 327.422 200.235 325.313 213.828 323.594C227.657 321.875 241.485 323.516 255.469 322.891C310.703 320.469 366.094 325.703 421.328 328.828C444.297 330.156 467.266 329.375 490.157 330.859C496.172 331.25 650 329.063 655.391 332.188C660.547 335.156 660.782 341.562 657.969 347.5C582.657 347.734 365.391 345.859 289.844 348.516C261.25 349.531 232.813 350.078 204.219 348.516C192.657 347.891 180.938 346.641 169.375 346.563C164.61 346.484 153.594 349.141 149.219 346.406C142.657 342.344 147.422 337.031 145.703 330.938C144.532 326.719 140.703 325.859 142.422 323.359Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M546.094 365.781C546.094 365 546.094 366.64 546.094 365.781C552.266 381.875 548.594 424.531 548.828 441.875C548.984 459.922 551.641 477.578 553.359 495.547C554.766 510.39 557.188 523.672 557.969 538.906C559.375 539.297 562.578 539.297 563.984 538.828C565.781 509.687 563.984 481.172 562.5 451.953C561.328 428.75 562.344 387.89 560.391 365.781C555.078 365.937 550.547 361.953 546.094 365.781Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M255.625 365.781C255.625 365 255.625 366.64 255.625 365.781C249.454 381.875 253.125 424.531 252.891 441.875C252.735 459.922 250.079 477.578 248.36 495.547C246.954 510.39 244.532 523.672 243.75 538.906C242.344 539.297 239.141 539.297 237.735 538.828C235.938 509.687 237.735 481.172 239.219 451.953C240.391 428.75 239.375 387.89 241.329 365.781C246.641 365.937 251.25 361.953 255.625 365.781Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M346.25 377.734C344.063 378.594 346.875 388.75 347.188 393.047H456.406C456.406 391.641 456.406 391.328 456.406 392.109C456.094 387.187 453.672 382.266 455.469 377.656H346.25V377.734Z"
          stroke="#005B9D"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M300.156 506.094C300 506.406 299.844 506.484 299.531 506.094H300.156Z"
          fill="#F5F5F5"
        ></path>
        <path
          d="M500 483.047C499.766 487.422 498.984 491.953 499.141 496.64C499.219 499.219 498.906 504.844 499.453 506.094C477.734 506.094 459.297 507.89 437.813 507.89C437.813 499.765 442.344 420.156 442.344 405C442.344 397.265 434.922 391.719 428.828 386.953C420.938 386.953 377.422 386.953 373.047 386.953C366.953 391.719 359.531 397.265 359.531 405C359.531 420.078 364.063 499.687 364.063 507.89C342.578 507.89 324.141 506.094 302.422 506.094C302.969 504.844 302.656 499.219 302.734 496.64C302.891 492.031 302.109 487.422 301.875 483.047C300.547 455 301.953 422.89 306.328 395.625C307.891 385.703 307.578 372.89 316.563 367.5C321.563 364.453 479.844 364.219 485.313 367.5C494.375 372.89 493.984 385.703 495.547 395.625C499.844 422.89 501.328 454.922 500 483.047Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M497.891 506.094C497.656 506.484 497.422 506.406 497.266 506.094H497.891Z"
          fill="#F5F5F5"
        ></path>
        <path
          d="M400.781 214.141C435.078 214.141 472.891 217.969 496.016 245.859C505.625 257.422 506.563 276.328 511.094 290.312C513.125 296.562 514.219 309.297 514.453 315.859C515.156 333.828 504.531 330.156 490.469 331.406C479.922 332.344 470.859 333.984 460.313 332.031C454.375 330.937 445 331.484 440 329.375L361.719 322.344C356.719 324.453 347.344 323.906 341.406 325C330.859 326.953 321.797 325.312 311.25 324.375C297.109 323.125 286.562 326.797 287.266 308.828C287.5 302.266 288.594 296.562 290.625 290.312C295.156 276.328 296.172 257.422 305.703 245.859C328.828 217.891 366.641 214.141 400.938 214.141H400.781Z"
          fill="#7D55FF"
        ></path>
        <path
          d="M345.469 325.625C345 311.875 335 294.062 329.297 281.484C325.781 273.75 322.5 266.875 320 258.906C320 258.828 320 258.828 319.922 258.75C318.125 252.969 322.422 247.109 328.516 247.109H476.25C481.016 247.109 483.75 252.422 481.094 256.406C474.453 266.016 468.672 278.75 463.828 287.109C456.328 299.922 446.25 323.359 440.938 335C423.672 335.703 402.891 334.531 384.297 333.828C373.047 333.281 354.844 330.234 345.469 325.625Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M412.656 288.672C412.656 295.156 407.344 300.469 400.859 300.469C394.375 300.469 389.062 295.156 389.062 288.672C389.062 283.359 391.953 278.906 396.875 277.031C398.984 276.25 401.094 276.875 403.125 277.734C412.344 281.562 415.234 294.687 405.312 299.766C392.422 306.484 381.562 276.875 400.859 276.875C407.344 276.875 412.656 282.187 412.656 288.672Z"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M411.094 197.812V223.906C411.094 229.531 406.484 234.141 400.859 234.141C395.234 234.141 390.625 229.531 390.625 223.906V197.812C390.625 192.187 395.234 187.578 400.859 187.578C403.672 187.578 406.25 188.75 408.125 190.547C410 192.422 411.094 195 411.094 197.812Z"
          fill="#EED3AC"
        ></path>
        <path
          d="M411.094 197.812V207.266C403.672 206.406 396.719 204.062 390.625 200.391V197.734C390.625 192.109 395.234 187.5 400.859 187.5C403.672 187.5 406.25 188.672 408.125 190.469C410 192.422 411.094 195 411.094 197.812Z"
          fill="#353535"
        ></path>
        <path
          d="M441.094 204.141H417.031C388.359 204.141 365.156 180.938 365.156 152.266H441.172C455.469 152.266 467.109 163.906 467.109 178.203C467.031 192.578 455.469 204.141 441.094 204.141Z"
          fill="#EED3AC"
        ></path>
        <path
          d="M376.484 174.375C371.25 179.609 362.812 179.609 357.578 174.375C352.344 169.141 352.344 160.703 357.578 155.469"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M429.375 194.688C430.234 197.422 436.094 198.359 437.656 196.172"
          stroke="#353535"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M410.547 168.437C411.328 167.656 412.265 167.187 413.203 166.797C414.14 166.406 415.078 166.172 416.015 166.016C416.953 165.859 417.89 165.781 418.906 165.859C419.843 165.859 420.859 166.016 421.875 166.25H421.953C423.203 166.562 423.906 167.812 423.672 168.984C423.437 170.156 422.109 170.937 420.937 170.703C420.781 170.703 420.625 170.625 420.468 170.547C419.922 170.234 419.218 170.078 418.515 169.844C417.812 169.687 417.031 169.609 416.328 169.531C414.843 169.453 413.359 169.687 412.343 170.312L412.265 170.391C411.64 170.781 410.937 170.625 410.547 170C410.078 169.531 410.156 168.906 410.547 168.437Z"
          fill="#353535"
        ></path>
        <path
          d="M450.313 171.25C450.078 170.938 449.61 170.547 449.063 170.313C448.516 170 447.813 169.844 447.11 169.688C445.703 169.375 444.063 169.375 442.656 169.609H442.578C441.875 169.766 441.25 169.297 441.094 168.594C441.016 167.969 441.328 167.422 441.797 167.188C443.594 166.406 445.391 166.016 447.344 165.938C448.281 165.938 449.297 165.938 450.313 166.172C451.328 166.406 452.422 166.719 453.516 167.578L453.828 167.813C454.922 168.594 455.156 170.156 454.375 171.328C453.594 172.422 452.031 172.656 450.86 171.875C450.703 171.719 450.469 171.484 450.313 171.25Z"
          fill="#353535"
        ></path>
        <path
          d="M412.734 174.844C413.047 173.047 414.766 171.875 416.484 172.188C417.344 172.344 417.969 172.734 418.516 173.359"
          stroke="#353535"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M443.438 174.922C443.906 174.141 444.766 173.516 445.781 173.437C447.578 173.203 449.219 174.453 449.453 176.25"
          stroke="#353535"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M435.234 186.25C435.703 187.031 437.969 186.953 438.594 185.937C439.141 185.078 438.281 182.89 437.891 183.281"
          stroke="#353535"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M489.766 150.156C488.437 149.61 486.719 150.235 486.797 151.25C487.109 155 485 158.594 480.781 161.016C473.672 165.078 463.125 164.297 456.562 161.016C452.969 159.219 451.016 156.797 450.078 154.844C449.609 153.828 447.5 153.672 446.641 154.531C443.516 157.656 438.359 159.141 434.453 158.36C431.016 157.735 428.437 155.313 427.5 152.5C425.547 154.375 421.406 157.735 414.375 159.688C400.937 163.281 382.578 160.078 375.625 151.641C374.844 150.703 368.828 143.047 375.625 136.406C381.719 130.391 393.203 130.156 394.297 130.156C393.828 125.391 397.031 121.016 402.578 118.985C406.328 117.578 413.281 116.485 417.812 118.985C420.156 120.313 420.937 122.031 421.25 123.047C425.156 120.156 437.266 112.031 455.859 110.938C472.656 110 495 114.688 497.344 123.047C498.125 125.703 496.719 128.36 494.609 130.625C504.375 131.25 511.719 135.703 512.578 140.938C513.125 144.453 510.859 149.297 504.297 151.25C499.687 152.578 494.141 152.11 489.766 150.156Z"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M362.188 166.016C364.609 166.016 365.234 166.797 366.094 169.063"
          stroke="#78D2EE"
          strokeWidth="3.2234"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M365.078 166.328C365.703 165.312 366.563 164.375 367.734 164.062"
          stroke="#78D2EE"
          strokeWidth="3.2234"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M364.922 157.891C367.5 158.594 370.156 158.672 372.578 157.969C374.375 157.422 375.938 156.562 377.109 155.547"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M383.906 126.328C382.031 124.532 379.375 122.657 375.86 121.641C363.516 117.969 353.125 128.438 352.5 129.141C350.625 131.094 344.766 137.188 346.328 144.688C346.641 146.25 347.266 147.735 348.125 149.141"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M346.172 395.86C348.281 395.547 355.547 397.344 358.281 399.922"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M477.031 440.156C477.031 445.469 476.797 451.172 477.344 456.25C478.985 454.687 482.266 453.672 483.906 451.641C484.219 457.109 484.063 462.734 484.063 468.281"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M140 473.828C154.453 464.531 186.641 441.25 186.25 423.594C165.234 420.859 145.313 444.219 133.125 457.578C140.547 450.156 171.719 405 163.516 396.25C152.344 384.375 122.891 440.859 121.875 451.406C122.109 442.344 120.938 433.594 119.922 424.609C118.594 412.344 120.938 377.812 108.516 371.016C90.547 391.875 111.797 441.562 111.797 465.781C103.672 463.359 86.0938 430.703 72.1095 438.672C55.9376 447.969 96.4845 488.047 103.438 493.047C88.2813 492.656 76.6407 494.375 83.7501 513.516C88.2032 525.625 101.719 527.031 112.813 528.203C124.609 529.453 148.203 513.125 147.891 500.156C144.922 500.156 142.188 498.984 139.297 498.984C145.547 495.781 149.375 486.328 150.938 479.922C145.859 478.984 143.984 476.328 140 473.828Z"
          fill="#7D55FF"
        ></path>
        <path
          d="M102.734 559.218C107.031 564.531 114.922 564.843 123.047 561.875C135.859 557.187 140.781 528.828 147.109 515.312C125.703 515.078 104.844 522.5 84.2188 520.937C83.2813 520.937 95.7813 550.546 102.734 559.218Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M100.312 526.328C117.109 528.594 132.344 521.016 148.203 521.641C147.656 533.203 142.969 552.891 133.75 561.25C125.781 568.516 112.656 565.313 102.422 566.016C103.359 566.094 104.219 566.25 105.156 566.328"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M205.312 187.265C220.078 186.015 236.484 188.281 251.641 188.281H268.75"
          stroke="white"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M575.625 128.672C590.391 127.422 606.797 129.687 621.953 129.687H639.062"
          stroke="white"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M111.719 122.109H184.531"
          stroke="white"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M623.438 61.1719H696.25"
          stroke="white"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M267.891 73.0469H344.453"
          stroke="white"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M511.25 543.828C516.484 540.547 536.719 542.422 544.453 542.813L511.25 543.828Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M583.672 563.906C596.562 564.219 610.547 558.984 623.047 556.563C637.031 553.828 646.094 557.109 658.984 562.187C672.5 567.5 686.641 568.906 701.406 568.984"
          fill="#C4B6FF"
        ></path>
        <path
          d="M742.344 195.703C740.313 193.984 737.891 196.25 735.313 195.703C731.172 194.844 726.719 194.219 722.344 195.469C722.344 195.625 722.344 195.703 722.344 195.859C722.422 195.859 722.578 195.781 722.734 195.703C722.5 196.406 722.422 197.109 722.344 197.891C722.344 197.188 722.344 196.484 722.344 195.781C721.641 196.016 721.328 196.016 721.641 195.625C721.875 195.547 722.109 195.469 722.344 195.391C722.422 191.641 722.578 187.812 722.656 183.984C722.734 180.156 722.188 171.875 722.188 171.875C722.188 171.875 706.484 174.453 707.109 174.453C707.109 183.906 707.344 193.359 707.344 202.891C706.016 201.328 703.047 204.062 696.641 201.406C696.641 195.625 696.875 189.922 697.031 183.984C697.109 180.156 696.562 171.875 696.562 171.875L681.484 174.453C681.484 185.938 681.875 197.344 681.641 208.828C681.328 221.797 681.016 234.609 681.016 247.578C681.016 250.859 681.016 264.297 682.891 266.562C683.672 267.5 685.703 266.953 686.484 267.031C688.203 267.187 689.922 267.188 691.641 267.734C693.047 268.125 697.422 271.172 698.594 269.453C698.828 269.141 735.156 270.625 739.063 270.625C741.016 270.625 742.812 271.641 744.766 271.641C742.969 247.344 741.25 220 742.344 195.703ZM722.344 197.969C722.344 198.75 722.344 199.453 722.344 200.234C722.422 202.031 722.578 203.906 722.5 205.469C722.422 206.328 722.422 207.109 722.422 207.969C722.344 205.391 722.344 202.734 722.422 200.234C722.344 199.453 722.344 198.672 722.344 197.969Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M552.969 267.969C552.422 269.453 552.656 270.937 554.531 271.328C555.938 271.641 558.36 271.406 559.922 271.406C563.594 271.406 567.344 271.406 571.016 271.406C590.938 271.406 652.188 276.094 672.11 276.016C693.672 276.016 715.157 276.016 736.719 275.938C746.797 275.938 756.875 275.938 766.953 275.938C765.938 274.688 765.625 273.594 764.297 272.344C763.438 271.484 762.578 270.391 763.438 269.453C762.891 270 746.328 269.453 744.922 269.453C732.032 269.453 719.219 269.453 706.328 269.453"
          fill="#B5CDFB"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M580.787 247.583H672.105V262.813C672.105 263.586 671.478 264.214 670.704 264.214C669.93 264.214 669.303 263.586 669.303 262.813V250.385H583.589V262.813C583.589 263.586 582.962 264.214 582.188 264.214C581.414 264.214 580.787 263.586 580.787 262.813V247.583Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M722.578 255.859V183.203"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M708.75 212.969V271.797"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M202.344 286.719H194.531L202.344 253.906H210.156L202.344 286.719Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M202.5 251.797C205 251.797 207.969 251.484 210.469 251.797C210.547 248.359 210.156 244.922 210.156 241.563C210.156 240.469 210.313 238.516 209.844 237.891C208.047 241.875 205.078 245.234 203.125 249.062C202.734 249.844 202.578 250.937 202.5 251.797Z"
          fill="#B5CDFB"
        ></path>
        <path
          d="M178.906 286.719H186.719L178.906 266.25H171.094L178.906 286.719Z"
          fill="#C4B6FF"
        ></path>
        <path
          d="M173.516 254.141C175.391 257.344 176.875 261.172 178.047 264.766C175.703 264.688 172.578 264.297 170.312 264.922C171.25 260.938 171.094 256.484 172.812 252.656C172.891 253.203 173.281 253.75 173.516 254.141Z"
          fill="#B5CDFB"
        ></path>
        <path
          d="M499.062 107.578C500.625 106.562 503.047 105.469 504.766 104.141"
          stroke="#FFE458"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M508.125 120.078C510.469 119.609 513.125 119.219 515.547 119.531"
          stroke="#FFE458"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M337.734 172.344C334.375 171.875 330.078 172.422 329.219 176.328"
          stroke="#FFE458"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M597.344 336.016C603.672 335.938 610.625 338.125 616.641 336.563"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M620.078 341.64C625.469 340.312 631.562 341.094 637.109 341.094"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M329.141 324.062C334.219 326.328 343.203 324.297 349.063 324.062C353.359 323.906 358.672 324.922 362.656 323.516"
          stroke="#FFE458"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M245.078 372.344C245.625 371.875 246.172 371.797 246.719 372.266C246.719 373.125 246.953 373.75 246.641 374.609C244.219 373.828 243.359 371.641 246.719 371.25"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M551.328 371.25C551.485 370.937 551.328 370.078 551.407 369.609C552.11 369.687 552.813 369.375 553.516 369.609C553.125 371.641 553.75 370.937 551.875 371.719C551.25 370.703 551.25 369.609 551.328 368.359"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M203.047 357.031C225.625 357.031 248.672 355.938 271.25 355.312"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M519.531 353.594C526.719 357.266 539.453 355.469 547.422 355.703C558.75 356.094 570.078 356.406 581.484 356.406"
          stroke="#78D2EE"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M192.812 299.062C203.516 300.781 188.047 313.438 199.062 316.641"
          stroke="white"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M206.25 334.531C206.172 334.609 206.094 334.687 206.094 334.687C205.781 334.922 205.469 334.766 205.078 334.844C202.266 335.469 199.063 335.156 196.172 335.156C193.047 335.156 190 335.156 186.875 335.156C184.766 335.156 182.109 334.922 179.531 334.687C176.641 334.453 174.453 331.953 174.609 329.063C175 318.906 175.625 297.344 175.547 295C175.469 293.516 175.547 291.953 175.547 290.469C175.547 289.219 175.703 287.969 175.859 286.719C179.688 286.563 183.594 286.719 187.422 286.719C190.234 286.719 192.969 286.563 195.703 286.875C197.969 287.188 200.313 287.578 202.656 287.266C204.219 287.031 205.469 286.641 207.109 286.641C207.109 286.641 207.109 291.641 207.109 291.953C207.109 299.141 207.109 306.406 207.109 313.594C207.109 317.344 207.109 321.094 207.109 324.844C207.109 326.562 207.656 328.281 207.422 329.922C207.188 330.937 206.953 333.594 206.25 334.531Z"
          stroke="#FFE458"
          strokeWidth="3.586"
          strokeMiterlimit="10"
        ></path>
        <path
          d="M319.531 158.75C321.797 157.5 324.531 157.344 326.953 157.031"
          stroke="#FFE458"
          strokeWidth="3.5865"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
      </svg>
    </>
  );
}
